import { css } from "styled-components";
import { style } from "./style";
import { focusOutline } from "./utils/focusOutlineStyle";

export const tabListStyle = css`
  width: 100%;
  list-style: none;
  padding: 0;
  background: none;
  border-bottom: 1px solid ${style.colors.grey.primary};
  margin: 0;
`;

export const legacyTabListStyle = css`
  width: 100%;
  list-style: none;
  padding: 0;
  border-bottom: 2px solid ${style.colors.shadesOfGrey["2"]};
  margin: 0;
`;

export const listItemStyle = css`
  display: inline-block;
`;

export const legacyListItemStyle = css`
  display: inline-block;
  height: 50px;
  line-height: 48px;
  margin: 0 22px -2px 0;

  /*
   * Temporary workaround for style coming from Walrus' FlexboxGrid
   * https://github.internal.digitalocean.com/digitalocean/walrus/blob/f9f1559aee6429dca93051b185f2b1e891d86934/src/components/FlexboxGrid.tsx#L30
   * TODO: Fix in Walrus
   */
  &:last-child {
    margin-bottom: -2px;
  }
`;

export const tabStyle = css`
  display: inline-flex;
  align-items: center;
  height: ${style.vars.height.small};
  color: ${style.colors.grey.dark};
  font-size: ${style.vars.fontSize.base};
  font-weight: ${style.vars.fontWeight.bold};
  padding: 0 ${style.vars.whitespace.regular};
  border: 1px solid transparent;
  border-radius: ${style.vars.borderRadius.base} ${style.vars.borderRadius.base} 0 0;
  margin-bottom: -1px;

  &:hover {
    color: ${style.colors.grey.dark};
    background-color: ${style.colors.grey.lightest};
    border-bottom-color: ${style.colors.grey.primary};
  }

  &:focus-within,
  &:focus {
    ${focusOutline()}
  }

  &:active {
    color: ${style.colors.grey.darkest};
    border: 1px solid ${style.colors.grey.primary};
    border-bottom-color: white;
  }
`;

export const legacyTabStyle = css`
  display: block;
  border-bottom: none;
  color: ${style.colors.shadesOfGrey["7"]};
  font-weight: 600;

  &:hover {
    color: ${style.colors.shadesOfGrey["8"]};
    border-bottom: 2px solid ${style.colors.shadesOfGrey["7"]};
  }
`;

// The next two constants need to be style objects instead of styled components
// because they get passed in to react-router's NavLink component:
// https://reacttraining.com/react-router/web/api/NavLink/activestyle-object
export const selectedTabStyle = {
  color: style.colors.grey.darkest,
  border: `1px solid ${style.colors.grey.primary}`,
  borderBottomColor: "white",
};

export const legacySelectedTabStyle = {
  color: style.colors.grey.darkest,
  borderBottom: `2px solid ${style.colors.blue.primary}`,
};
